<template>
  <div
  :id="this.id"
  @contextmenu.prevent="handler($event)"
  class="sitebuilder-element-container"
  element="CheckoutComponent"
  :data-hide-desktop="!this.internal_config.showDesktop"
  :data-hide-mobile="!this.internal_config.showMobile"
  :keyChange="keyChange"
  :config-properties="JSON.stringify(this.internal_config)"
  :style="style"
  v-on:click="focusElement($event)"
  >
    <vue-draggable-resizable ref="draggableResizable"
      :w="parseInt(internal_config.width)"
      :h="parseInt(internal_config.height)"
      :draggable="false"
      @resizing="onResize"
      :class="`vdr${internal_config.steps}`"
    >
      <sync-drag :target="this"/>

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-CheckoutComponent'>
        <img class="svg-icon normal-action"
           src="static/images/icons/engrenagem.svg"
           v-tooltip="{content:$t('ct-option-supercheckout'),  class: 'tooltip-custom'}"
           @click="configure()"
        />
      </options-element-bar>
      <div ref="mountingPoint" class="s-checkout-widget" :dir="dir()"></div>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import Model from './Model';
import OptionsElementBar from '../OptionsElementBar';
import {apiUrl} from '../../../../js/services/integrations-internas/supercheckout';

export default {
  name: 'CheckoutComponent',
  props: ['config', 'id', 'preview'],

  components: {OptionsElementBar},

  data() {
    return Model.data();
  },

  computed: {
    style() {
      let width = `${this.internal_config.width}`;
      let maxWidth = `${this.internal_config.maxWidth}`;

      if (!width.match(/px$/)) width += 'px';
      if (!maxWidth.match(/px$/)) maxWidth += 'px';

      return `left:  ${this.internal_config.left};
              z-index: ${this.internal_config.zIndex};
              max-width: ${maxWidth};
              width: ${width};
              margin: 0 auto;
              top: ${this.internal_config.top}`;
    }
  },

  watch: {
    'internal_config.steps'(value) {
      if (!value) return;
        this.internal_config.width = value === 3 ? '748px' : value === 2 ? '325px' :'748px';
        this.internal_config.maxWidth = value === 3 ? '768px' : value === 2 ? '450px' :'1920px';
        this.props.width = value === 3 ? '748px' : value === 2 ? '325px' : '748px';
        this.props.maxWidth = value === 3 ? '768px' : value === 2 ? '325px' : '1920px';
    }
  },

  methods: {
    dir() {
      let defaultLocale = (window.getCookie('languageEditorUser') != null) ? window.getCookie('languageEditorUser') : 'en_US';
      var idiomaNavegador = (navigator.browserLanguage !== undefined) ? navigator.browserLanguage : navigator.language;

      if (
        (typeof defaultLocale != 'undefined' && ['he', 'ja', 'ar'].includes(defaultLocale)) ||
        (typeof idiomaNavegador != 'undefined' && ['he', 'ja', 'ar'].includes(idiomaNavegador.substring(0, 2)))
      ) {
        return 'rtl';
      } else return false;
    },

    configure() {
      this.$root.$emit('openCheckoutModal', this.internal_config, this, this.save, 'config');
    },

    save(config) {
      this.internal_config = config;
      this.loadAssets();
    },

    keyChange() {},

    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },

    onResize: function(x, y, width, height) {
      this.internal_config.width = width;
      if (this.$refs.mountingPoint)
        height = this.$refs.mountingPoint.clientHeight + 3;

      this.internal_config.height = height;
    },

    showResources() {
      return {};
    },

    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },

    build(config) {
      // sanitize old configuration
      if (!config.version || config.version === 'v1') {
        this.$set(config, 'texts', {
          baloon: config.baloon_text,
          step1_title: this.$t('ct-checkout-shipping'),
          step1_text: this.$t('ct-checkout-where-to'),
          step2_title: this.$t('ct-checkout-your-info'),
          step2_text: this.$t('ct-checkout-pay-it'),
          buy_button: config.buy_button_text,
          pay_button: config.pay_button_text,
          buy_button_sub: config.buy_button_subtext,
          bottom_info: config.bottom_info,
          payment_bottom_info: this.$t('ct-checkout-secure-payments')
        });
        delete config.baloon_text;
        delete config.buy_button_text;
        delete config.pay_button_text;
        delete config.buy_button_subtext;
        delete config.bottom_info;
        if (!config.steps) this.$set(config, 'steps', 1);
        if (!config.steps) this.$set(config, 'maxWidth3', 1920);
        if (!config.steps) this.$set(config, 'width', '748px');
        if (!config.steps) config.width = '748px';
        config.version = 'v1.2';
      }
      if (!config.version || config.version === 'v1.2') {
        this.$set(config, 'texts', {
          ...config.texts,
          continue_button: this.$t('ct-checkout-continue-button'),
          security_title: this.$t('ct-checkout-security-title'),
          security_text: this.$t('ct-checkout-security-content'),
          payment_button: this.$t('ct-checkout-payment-button'),
          thank_you_title: this.$t('ct-checkout-thankyou-title'),
          thank_you_text: this.$t('ct-checkout-thankyou-text'),
          get_product_button: this.$t('ct-checkout-thankyou-get-product-button')
        });
        if (!config.steps) this.$set(config, 'steps', 1);
        if (!config.steps) this.$set(config, 'maxWidth3', 1920);
        if (!config.steps) this.$set(config, 'width', '748px');
        if (!config.steps) config.width = '748px';
        config.version = 'v1.3';
      }
      if (!config.version || config.version === 'v1.3') {
        this.$set(config, 'texts', {
          ...config.texts,
          continue_button: this.$t('ct-checkout-continue-button'),
          security_title: this.$t('ct-checkout-security-title'),
          security_text: this.$t('ct-checkout-security-content'),
          payment_button: this.$t('ct-checkout-payment-button'),
          thank_you_title: this.$t('ct-checkout-thankyou-title'),
          thank_you_text: this.$t('ct-checkout-thankyou-text'),
          get_product_button: this.$t('ct-checkout-thankyou-get-product-button')
        });
        if (!config.steps) this.$set(config, 'steps', 1);
        if (!config.steps) this.$set(config, 'maxWidth3', 1920);
        if (!config.steps) this.$set(config, 'width', '748px');
        if (!config.steps) config.width = '748px';
        config.version = 'v1.4';
      }

      if (!config.steps) this.$set(config, 'width', '748px');
      if (!config.steps) config.width = '748px';

      this.internal_config = config;
      if (!config.sellableHash)
        this.configure();
    },

    loadAssets() {
      if (!window.checkoutConfigs)
        window.checkoutConfigs = {baseURL: apiUrl(), sellable: {}};

      window.checkoutConfigs.sellable[this.config.sellableHash] = {
        ...this.internal_config,
        preview: 1
      };
      this.$refs.mountingPoint.innerHTML = '';
      if (this.assets.mount && this.$refs.mountingPoint.childNodes.length)
        this.$refs.mountingPoint.removeChild(this.assets.mount);

      this.assets.mount = document.createElement('div');
      this.assets.mount.classList.add('sc-widget');
      this.assets.mount.setAttribute('data-hash', this.internal_config.sellableHash);
      this.assets.mount.setAttribute('data-version', this.internal_config.version);
      this.assets.mount.setAttribute('data-preview', '1');
      this.$refs.mountingPoint.appendChild(this.assets.mount);
      this.$nextTick(() => {
        // load translations
        if (this.assets.i18n) document.body.removeChild(this.assets.i18n);
        this.assets.i18n = document.createElement('script');
        this.assets.i18n.src = `${window.checkoutConfigs.baseURL}/lang/${this.internal_config.language}?scope=checkoutTranslations`;
        this.assets.i18n.onload = () => {
          // load js
          if (this.assets.js) document.body.removeChild(this.assets.js);
          this.assets.js = document.createElement('script');
          this.assets.js.src = `${window.checkoutConfigs.baseURL}/widget/app.js?v=${this.internal_config.version}`;
          this.assets.js.onload = () => {
            setTimeout(() => {
              this.internal_config.height = this.$refs.mountingPoint.clientHeight + 3;
            }, 2000);
          };
          document.body.appendChild(this.assets.js);
        };
        document.body.appendChild(this.assets.i18n);
      });
    }
  },

  mounted() {
    this.build(this.$props.config);

    this.$root.$on('setConfigElement', (id, obj) => {
      if (+this.id === +id)
        this.internal_config = obj;
    });

    this.loadAssets();
  }
};
</script>
<style lang="scss" scoped>
[data-device="desktop"] {
  .vdr1 {
    height    : auto !important;
    max-width : 1920px !important;
    min-width : 801px !important;
  }

  .vdr2 {
    height    : auto !important;
    max-width : 450px !important;
    min-width : 410px !important;
  }

  .vdr3 {
    height    : auto !important;
    max-width : 768px !important;
    min-width : 720px !important;
  }
}

.s-checkout .sweet-modal {
  padding : 1rem 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Checkout.vue